import { formatDate, formatCurrency } from '../../utils/localization';
import { sanitizeParams } from './sanitizeParams/sanitizeParams';

const CUSTOM_TEMPLATES = {
    localized_fiverr_credits_removed: localizedFiverrCreditsRemovedTemplate,
    localized_fiverr_credits_removed_no_date: localizedFiverrCreditsRemovedTemplate,
    business_spending_limit_set: localizedSpendingLimitAmountTemplate,
    business_deposit_made: localizdDepositMadeTemplate,
};

const EXCLUDE_FROM_SANITIZE_SUB_TYPES = ['external_source_notification'];

function localizedFiverrCreditsRemovedTemplate(item, i18n) {
    const { amount, currency, date } = item.msgParams;

    const formattedAmount = formatCurrency({ amount, currency });
    const formattedDate = formatDate(date);
    const params = { ...item.msgParams, amount: formattedAmount, date: formattedDate };
    const sanitizedParams = sanitizeParams(params);

    return i18n.t(`realtime_notifications.types.${item.subType}`, sanitizedParams);
}

function localizedSpendingLimitAmountTemplate(item, i18n) {
    const { spending_limit: amount, currency } = item.msgParams;

    const formattedAmount = formatCurrency({ amount, currency });
    const params = { ...item.msgParams, amount: formattedAmount };
    const sanitizedParams = sanitizeParams(params);

    return i18n.t(`realtime_notifications.types.${item.subType}`, sanitizedParams);
}

function localizdDepositMadeTemplate(item, i18n) {
    const { deposit_amount: amount, currency } = item.msgParams;

    const formattedAmount = formatCurrency({ amount, currency });
    const params = { ...item.msgParams, amount: formattedAmount };
    const sanitizedParams = sanitizeParams(params);

    return i18n.t(`realtime_notifications.types.${item.subType}`, sanitizedParams);
}

export function getContentForItem(item, i18n) {
    if (CUSTOM_TEMPLATES[item.subType]) {
        const template = CUSTOM_TEMPLATES[item.subType];
        return template(item, i18n);
    } else {
        const sanitizedParams = EXCLUDE_FROM_SANITIZE_SUB_TYPES.includes(item.subType)
            ? item.msgParams
            : sanitizeParams(item.msgParams);
        return i18n.t(`realtime_notifications.types.${item.subType}`, sanitizedParams);
    }
}
